import Scriba from 'react-scriba';

export class DataMandat {
    static _chargementMandatAlerte(loginCompte) {
        let objet = {
            "loginCompte": loginCompte,
        };

        var url = "api/Liste/GetMandatAlerte";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheMandat = (idMandat) => {
        const objet = { idMandat };
        const url = "api/Fiche/FicheMandat";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    //static _onEnregistrementMandat(mandat, idMandat, lotsSelectionnes, listeDesAlertesSelectionnees) {
    static _onEnregistrementMandat(mandat, idMandat, listeDesAlertesSelectionnees) {
        const objet = {
            "mandat": mandat,
            "idMandat": idMandat,
            //"lotsSelectionnes": lotsSelectionnes,
            "listeDesAlertesSelectionnees": listeDesAlertesSelectionnees
        }

        const url = "api/MAJDonnees/EnregistrementMandat";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementMandatCommercialisateurLePlusBasPourUnLotCommercial(idOperation, idLotCommercial, loginCompte) {
        let objet = {
            "loginCompte": loginCompte,
            "idOperation": idOperation,
            "idLotCommercial": idLotCommercial
        };

        var url = "api/Get/GetMandatCommercialisateurLePlusBasPourUnLotCommercial";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionMandat(idMandat) {
        let objet = {
            "idMandat": idMandat
        };
        var url = "api/MAJDonnees/SuppressionMandat";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesMandats(recherche, tri, letFiltreTypeMandat, filtreIdStatutMandat, filtreIdProduit, filtreIdTypeMandat, facteurNbreEnregistrement, pageIndex, filtreDateFinExpire) {
        let objet = {
            "recherche": recherche,
            "tri": tri,
            "filtreTypeMandat": letFiltreTypeMandat,
            "filtreIdStatutMandat": filtreIdStatutMandat,
            "filtreIdProduit": filtreIdProduit,
            "filtreIdTypeMandat": filtreIdTypeMandat,
            "filtreDateFinExpire": filtreDateFinExpire,
            "nbreEnreg": facteurNbreEnregistrement,
            "pageIndex": pageIndex
        };
        var url = "api/Liste/ListeDesMANDATS";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheMandatCommercialisation(idMandat, estTypeCompte) {
        let objet = {
            idMandat,
            estTypeCompte
        };
        var url = "api/Fiche/FicheMandatCommercialisation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheMandatCommercialisationListeLot(idMandat) {
        let objet = { idMandat };
        var url = "api/Liste/ListeLotMandat";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
}